<template>
    <div class="context-menu display-flex justify-center mt-xxs ml-xxs" style="width: 20px">
        <VDropdown
            placement="left"
            :distance="8"
            :triggers="['click']"
            :popper-triggers="['click']"
        >
            <div class="cta-holder display-flex justify-center align-items-center">
                <font-awesome-icon :icon="`fas fa-ellipsis-vertical`" />
            </div>
            <template #popper>
                <div class="popover-container p-xs">
                    <div
                        v-for="(item, index) in params.actionsList"
                        class="context-action"
                        @click="onActionClick(`${item?.actionName}`)"
                    >
                        <div
                            v-if="item?.name"
                            class="action-inner p-xs display-flex align-items-center"
                        >
                            <font-awesome-icon :icon="`fas ${item?.icon}`" />
                            <p class="small ml-sm">{{ item?.name }}</p>
                        </div>
                    </div>
                </div>
            </template>
        </VDropdown>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

const props = defineProps({
    params: {
        type: Object,
        required: true,
    },
})

const onActionClick = (actionName) => {
    const actionTarget = props.params.actionsList.find((action) => action.actionName === actionName)
    actionTarget[`${actionName}Action`](props.params)
}
</script>

<style lang="scss">
@use '@moatmetrics/armory/src/sass/token-utils' as tokens;

.context-action {
    cursor: pointer;
    border-radius: var(--border-radius-md);
    transition: all 0.3s ease-in-out;

    p,
    svg {
        color: var(--color-text-primary);
        transition: all 0.3s ease-in-out;
    }

    &:hover {
        background-color: var(--color-secondary);

        p,
        svg {
            color: var(--color-text-on-dark);
        }
    }
}

.cta-holder {
    background: var(--color-background-default);
    width: 30px;
    height: 30px;
    border-radius: var(--border-radius-full);
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    &:hover {
        background-color: var(--color-background-active);
    }
}
</style>
